/**
 * WordPress dependencies
 */
if (wp) {
    const {__} = wp.i18n;
    const {registerBlockStyle} = wp.blocks;

    registerBlockStyle('core/image', {
        name: 'rounded-corners',
        label: __('Rounded Corners 5px'),
        isDefault: false,
    });

    registerBlockStyle('core/image', {
        name: 'small-icon',
        label: __('Small icon'),
        isDefault: false,
    });
}
